import gql from "graphql-tag";

export const MY_TAX_GET_PERSONAL_DECLARATION = gql`
  query taxDeclarationPersonal($_id: Int!) {
    taxDeclarationPersonal(_id: $_id) {
      dateOfDeclaration
      isModifiedDeclaration
      state
      disabledStateFrom
      disabledStateTo
      isFinal
      disabilityPension
      disabilityPensionNumber
      disabilitySupport
      disabilitySupportNumber
      applyToWithdrawal
      noRequestRelief
    }
  }
`;
